import React from "react"
import BasicHero from "../../components/basic-hero"
import Calendly from "../../components/calendly/calendly"
import CTARow from "../../components/cta-row"
import { HandleImages } from "../../components/functions"
import Infographic from "../../components/improve-infographic"
import Layout from "../../components/layout"
import Resource from "../../components/resource"
import ResourcesWrapper from "../../components/resources-wrapper"
import SEO from "../../components/seo"
import { seodata } from "../../components/seo-data"
import SimpleSlide from "../../components/simple-slide"
import SimpleSlider from "../../components/simple-slider"
import SocialSlider from "../../components/social-slider"


var image;
var content = {
  hero: {
    title: (
      <span>
       Improve Cyber Security Skills

with Project Ares
      </span>
    ),
    text:<span>
     <h4 style={{margin:"0 0 .5em 0"}}> Can you confidently keep pace with sophisticated hackers?

     </h4>
     <h4 style={{margin:"0 0 .5em 0"}}>
     Unsure if the knowledge indicated in your cyber certs and accreditations is still fresh and ready to demonstrate?
</h4>
 
<p>With persistent threats on the rise, now is the time to embrace a new way to train in cyber security</p> 
<p>Project Ares is an award-winning online cyber security training platform suitable for professionals looking to advance in their career, grow in abilities, and align to specialized work-roles.</p>
    </span>  },

  calendly: {
    text: <span>We'd love to learn about your cyber training needs.<br/>  Schedule a consultation with us now.</span>,
  },


  cta1:{
    title:"Strengthen your cyber security reputation",
    text:"Advice for cyber leaders to protect their profession with strategic cyber training options.",
    url:"https://marketing.circadence.com/acton/fs/blocks/showLandingPage/a/36273/p/p-00e0/t/page/fm/0",
    cta:"Download Now"
  },
    
  cta2: {
    title: "Invest in your team. ",
    text:
      "Learn more about Project Ares to keep the cyber skills sharp in your organization. ",
    url:
      "/project-ares",
    cta: "Learn More",
  },
  social:{
    social1:{
      image:"",
      title:"",
      text:<span>I personally found Project Ares to be a great learning experience and thought the mission environment was seamless.<br/><span className="source">- Chris N UNCW,<br/> Cyber Security Operations Club</span></span>,
 
     
      url:""
    }
  },
 //URL NEEDS UPDATE!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  resources:{
    resource1:{
      
      title:<span>Gamification for Cyber Professional Development<span>Fact Sheet </span></span>,
      text:"Learn why gamified learning can support skills training and acquisition for today’s cyber security professionals.",
      url:"https://marketing.circadence.com/acton/attachment/36273/f-1ebf399b-baed-420b-a651-3156c6cf248c/1/-/-/-/-/Gamification%20Fact%20Sheet%20%28links%20to%20gamification%20blog%20post%29.pdf"
    },
    resource2:{
     
      title:<span>Cyber Ranges and How They Improve Security Training<span>Article </span></span>,
      text:"Learn about the benefits of cyber range training environments and how they’ve evolved to optimize training for professionals.",
      url:"/blog/cyber-ranges-101-and-how-they-improve-security-training/"
    },
    resource3:{
      
      title:<span>How it’s Built: Project Ares Missions<span>Webinar </span></span>,
      text:"Hear from Project Ares mission designers who are real-life cyber operators themselves, on how they’ve built mission scenarios in the platform to help professionals built the best cyber skills possible.",
      url:"https://marketing.circadence.com/acton/media/36273/webinar-how-its-built-project-ares"
    }, 
  },
  simple:{
    simple1:{
      text:"Build your resume: As you build your skills, align them to the NIST/NICE  Cybersecurity Workforce Framework.",
    },
    simple2:{
      text:"Rank yourself: How will your scores and XP stack up to others? Friendly competition through gamified elements can motivate your training.",
    },
    simple3:{
      text:"Improve at work: Train in realistic networks against real-world inspired threats to be better cyber defender for your organization.",
    },
    simple4:{
      text:"Cyber is complex: Be prepared. Integrate skills and optimize strategic thinking abilities with multi-faceted cyber activities.",
    },
    simple5:{
      text:"Train on your own schedule with browser-based training available anytime, from any location.",
    },
  }
}
 
 
class TechPage extends React.Component {
  render() {
    return (
      <Layout> <SEO title={seodata.improve.title} description={seodata.improve.description} keywords={seodata.improve.keywords} />
        <BasicHero
          title={content.hero.title}
          text={content.hero.text}
          image={<HandleImages name={'manHeadset'}/>}
        />
     
    <Infographic/>
     <Calendly text={content.calendly.text} inv={true} bgColor={"bright-blue"} />
     
                
     <SocialSlider>
    <SimpleSlide   image={<HandleImages name={'professionals'}/>} title={content.social.social1.title} text={content.social.social1.text} />
   
 

        </SocialSlider>


        <CTARow title={content.cta1.title} text={content.cta1.text} cta={content.cta1.cta} url={content.cta1.url} inv={false} bgColor={"deep-blue"} image={'document'}/>
        


        <h3>Additional Resources </h3>
        <ResourcesWrapper>
        <Resource  image={<HandleImages name={'gamification'}/>} title={content.resources.resource1.title} text={content.resources.resource1.text} url={content.resources.resource1.url}/>
        <Resource  image={<HandleImages name={'darkBG'}/>} title={content.resources.resource2.title} text={content.resources.resource2.text} url={content.resources.resource2.url}/>
        <Resource  image={<HandleImages name={'womanScreen'}/>} title={content.resources.resource3.title} text={content.resources.resource3.text} url={content.resources.resource3.url}/>
       
        </ResourcesWrapper>



        <SimpleSlider>
    <SimpleSlide   image={<HandleImages name={'pAScreen1'}/>} text={content.simple.simple1.text} />
    <SimpleSlide   image={<HandleImages name={'pAScreen2'}/>} text={content.simple.simple2.text} />
    <SimpleSlide   image={<HandleImages name={'pAScreen3'}/>} text={content.simple.simple3.text} />
    <SimpleSlide   image={<HandleImages name={'pAScreen4'}/>} text={content.simple.simple4.text} />
    <SimpleSlide   image={<HandleImages name={'pAScreen5'}/>} text={content.simple.simple5.text} />

        </SimpleSlider>
        <CTARow
          title={content.cta2.title}
          text={content.cta2.text}
          cta={content.cta2.cta}
          url={content.cta2.url}
          
          bgColor={"bright-blue"}
          image={"laptop"}
        />
      </Layout>
    )
  }
}

export default TechPage
